var map = {
	"./ContactsView.vue": 4051,
	"./HelpView.vue": 5020,
	"./HomeView.vue": 1752,
	"./PrivacyView.vue": 115,
	"./TermsView.vue": 931,
	"./ThemesView.vue": 9871
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 425;